import { type ReactNode } from 'react';
import { FormattedDate } from 'dibs-react-intl';

export const resolveSoldDate = ({
    itemSoldDate,
    isCurrentItem,
}: {
    itemSoldDate: string | null | undefined;
    isCurrentItem: boolean | undefined;
}): ReactNode | null => {
    if (isCurrentItem || !itemSoldDate) {
        return null;
    }

    const currentYear = new Date().getFullYear();
    const soldYear = new Date(itemSoldDate).getFullYear();

    return currentYear === soldYear ? (
        <FormattedDate month="long" value={itemSoldDate} />
    ) : (
        <FormattedDate year="numeric" value={itemSoldDate} />
    );
};
